/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormTextarea
} from "shards-react";
import { accessCheck } from "../../utils/tools";
import moment from 'moment-timezone'
import { WEB_PAYMENT_URL } from "../../environmentVariables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faFileInvoice, faFileInvoiceDollar, faSearch, faTimes, faArrowDown, faArrowUp, faExclamationTriangle, faCheckCircle, faTimesCircle, faEye, faPercent, faExternalLinkAlt, faFile, faEnvelope, faPhone, faBrain, faColumns, faList, faCheck, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import PageTitle from "../../components/common/PageTitle";
import Pagination from "../../components/common/Pagination";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import DownloadButton from "../../components/common/DownloadButton";
import EnhancedDateRangePicker from "../../components/common/EnhancedDateRangePicker";
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfDay, endOfDay, sub } from "date-fns";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

import "react-datepicker/dist/react-datepicker.css";
import RowActions from '../../components/common/RowActions';

// We're now using EnhancedDateRangePicker, which includes its own styles
/* const datePickerStyles = `
  .react-datepicker {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    border-radius: 6px;
    border: 1px solid #eaedf3;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
  
  .react-datepicker__header {
    background-color: #fff;
    border-bottom: 1px solid #eaedf3;
    padding-top: 10px;
  }
  
  .react-datepicker__current-month {
    color: #495057;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  .react-datepicker__day-name {
    color: #818ea3;
    font-size: 12px;
    margin: 3px;
  }
  
  .react-datepicker__day {
    color: #495057;
    margin: 3px;
    border-radius: 4px;
  }
  
  .react-datepicker__day:hover {
    background-color: rgba(33, 170, 115, 0.05);
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(33, 170, 115, 0.5);
    color: white;
  }
  
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: rgba(33, 170, 115, 0.5);
  }
  
  .react-datepicker__day--in-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    background-color: #21AA73;
    color: white;
  }
  
  .react-datepicker__navigation {
    top: 10px;
  }
  
  .react-datepicker__navigation-icon::before {
    border-color: #21AA73;
  }
  
  .react-datepicker__navigation:hover *::before {
    border-color: #21AA73;
  }
`; */

const Warnings = (props) => {

  const [citations, setCitations] = useState([]);
  const [startDate, setStartDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedStartDate = localStorage.getItem('enforcePlus_startDate');
    return savedStartDate ? new Date(savedStartDate) : startOfDay(new Date());
  });
  const [endDate, setEndDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedEndDate = localStorage.getItem('enforcePlus_endDate');
    return savedEndDate ? new Date(savedEndDate) : endOfDay(new Date());
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState(props.statusFilter || 'all');
  const [client, setClient] = useState(props.clientFilter || 'all');
  const [location, setLocation] = useState(props.locationFilter || 'all');
  const [sortBy, setSortBy] = useState('dateDesc')
  const [search, setSearch] = useState(props.searchFilter || '');
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(() => {
    // Try to load saved page size from localStorage
    const savedPageSize = localStorage.getItem('citations_page_size');
    return savedPageSize ? parseInt(savedPageSize, 10) : 25;
  });
  const [endablePdfMode, setEndablePdfMode] = useState(false);
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [selectedForAnalysis, setSelectedForAnalysis] = useState(null);
  // Add state for void confirmation modal
  const [showVoidModal, setShowVoidModal] = useState(false);
  const [warningToVoid, setWarningToVoid] = useState(null);
  // Column visibility state
  const [visibleColumns, setVisibleColumns] = useState(() => {
    // Try to load saved preferences from localStorage
    const savedPreferences = localStorage.getItem('citations_visible_columns');
    if (savedPreferences) {
      try {
        return JSON.parse(savedPreferences);
      } catch (e) {
        console.error("Error parsing saved column preferences", e);
      }
    }
    
    // Default columns if no saved preferences
    return {
      license_plate: true,
      id: true,
      date_time: true,
      location: true,
      issued_by: true,
      previous_offenses: false,
      total: true,
      status: true
    };
  });
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  // Add this state to track open dropdowns
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [activeCalendar, setActiveCalendar] = useState(null);

  // Add ref for the column selector button
  const columnSelectorRef = useRef(null);

  // Save column preferences whenever they change
  useEffect(() => {
    localStorage.setItem('citations_visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const allColumns = [
    { id: 'license_plate', label: 'License plate' },
    { id: 'id', label: '#ID' },
    { id: 'date_time', label: 'Date/Time' },
    { id: 'location', label: 'Location' },
    { id: 'issued_by', label: 'Issued by' },
    { id: 'previous_offenses', label: 'Citations' },
    { id: 'total', label: 'Total' },
    { id: 'status', label: 'Status' }
  ];

  const csvHeader = allColumns
    .filter(column => visibleColumns[column.id])
    .map(column => column.label);

  const getPreviousCitationsCount = (citation) => {
    if (!props.warnings || !citation) return 0;
    
    // Get all citations for the same license plate that were created before this one
    const previousCitations = props.warnings.filter(c => 
      c.license_plate === citation.license_plate && 
      new Date(c.created_at) < new Date(citation.created_at)
    );
    
    return previousCitations.length;
  };

  const generateFileData = () => {
    let citationsTemp = [...filterCitations()]
    let csvDataArray = citationsTemp.map(citation => {
      const rowData = [];
      
      if (visibleColumns.license_plate) rowData.push(citation.license_plate);
      if (visibleColumns.id) rowData.push(citation.violation_number);
      if (visibleColumns.date_time) rowData.push(moment(citation.created_at).format('MM/DD/Y h:mm a'));
      if (visibleColumns.location) rowData.push(citation.location_name);
      if (visibleColumns.issued_by) rowData.push(props.users.find(user => user.id === citation.user)?.name);
      if (visibleColumns.previous_offenses) rowData.push(getPreviousCitationsCount(citation));
      if (visibleColumns.total) rowData.push(citation.payment_on ? 
        parseFloat(parseFloat(citation.payment.amount) - ((citation?.payment?.card_last_four) ? parseFloat(citation.service_fee) : 0)).toFixed(2) :
        parseFloat(citation.total).toFixed(2));
      if (visibleColumns.status) rowData.push(getCsvStatus(citation));
      
      return rowData;
    });
    
    return [csvHeader, ...csvDataArray]
  }

  const generateList = () => {
    if (endablePdfMode) {
      return filterCitations()
    } else {
      return filterCitations().slice((page - 1) * pageSize, ((page - 1) * pageSize) + pageSize);
    }
  }

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    // Save to localStorage for persistence
    localStorage.setItem('citations_page_size', newSize.toString());
    // Reset to first page when changing page size
    setPage(1);
  }

  const getTargetElement = () => document.getElementById('content-id');

  const generateFilePdf = () => {
    const options = {
      method: 'save',
      resolution: Resolution.NORMAL,
      page: {
        margin: Margin.SMALL,
        format: 'A4',
        orientation: 'portrait',
      },
      canvas: {
        mimeType: 'image/jpeg',
        qualityRatio: 1
      },
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      filename: 'enforceplus_citations.pdf'
    };

    setEndablePdfMode(true);
    setTimeout(() => {
      generatePDF(getTargetElement, options);
      setTimeout(() => {
        setEndablePdfMode(false);
      }, 1000);
    }, 1000);
  }

  useEffect(() => {
    props.getAllCitations(startDate, endDate)
    // Save date range to Redux
    props.setDateRangeFilter({ startDate, endDate })
    document.title = 'Warnings: EnforcePlus admin';
    !accessCheck(props.user, 'citations') && (window.location.href = '/')
    props.clearCitation()
  }, [])

  useEffect(() => {
    props.getAllCitations(startDate, endDate)
  }, [startDate, endDate])

  useEffect(() => {
    setCitations(props.warnings)
  }, [props.warnings])

  useEffect(() => {
    if (props.warnings?.length > 0) {
      setCitations(props.warnings);
    }
  }, [status, client]);

  // useEffect(() => {
  //   if (props.addedLocation) {
  //     setAddedLocation(true);
  //     setTimeout(() => {
  //       setAddedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  //   if (props.updatedLocation) {
  //     setUpdatedLocation(true);
  //     setTimeout(() => {
  //       setUpdatedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  // }, [props.addedLocation, props.updatedLocation])

  
  
  const filterCitations = () => {
    let sortedCitations = [...citations];
    if (search !== '') {
      sortedCitations = sortedCitations.filter(citation => (
        citation.violation_number.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || citation.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || citation.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || (props.users?.find(user => user.id === citation.user)?.name || '').toLowerCase().indexOf(search.toLowerCase()) !== -1
      ))
    }
    
    sortedCitations = sortedCitations.filter(citation => citation.status !== 'void')

    if (client !== 'all') {
      props.setClientFilter(client)
      sortedCitations = sortedCitations.filter(citation => citation.client === client)
    }
    if (client === 'all') {
      props.setClientFilter(client)
    }
    if (location !== 'all') {
      props.setLocationFilter(location)
      sortedCitations = sortedCitations.filter(citation => citation.location === location)
    }
    if (location === 'all') {
      props.setLocationFilter(location)
    }
    if (sortBy === 'dateDesc') {
      sortedCitations = sortedCitations.sort((a, b) => a.created_at && b.created_at && moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1);
    }
    if (sortBy === 'dateAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.created_at && b.created_at && moment(a.created_at).isBefore(moment(b.created_at)) ? -1 : 1);
    }
    if (sortBy === 'licenseAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.license_plate.localeCompare(b.license_plate));
    }
    if (sortBy === 'licenseDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.license_plate.localeCompare(a.license_plate));
    }
    if (sortBy === 'idAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.violation_number.localeCompare(b.violation_number));
    }
    if (sortBy === 'idDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.violation_number.localeCompare(a.violation_number));
    }
    if (sortBy === 'locationAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.location_name.localeCompare(b.location_name));
    }
    if (sortBy === 'locationDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.location_name.localeCompare(a.location_name));
    }
    if (sortBy === 'userAsc') {
      sortedCitations = sortedCitations.sort((a, b) => props.users.find(user => user.id === a.user)?.name?.localeCompare(props.users.find(user => user.id === b.user)?.name));
    }
    if (sortBy === 'userDesc') {
      sortedCitations = sortedCitations.sort((a, b) => props.users.find(user => user.id === b.user)?.name?.localeCompare(props.users.find(user => user.id === a.user)?.name));
    }
    if (sortBy === 'totalAsc') {
      sortedCitations = sortedCitations.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? 1 : -1);
    }
    if (sortBy === 'totalDesc') {
      sortedCitations = sortedCitations.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? -1 : 1);
    }
    if (sortBy === 'statusAsc') {
      sortedCitations = sortedCitations.sort((a, b) => (a?.payment_on ? 'paid' : a?.dispute?.status === 'open' ? 'disputed' : 'unpaid').localeCompare(b?.payment_on ? 'paid' : b?.dispute?.status === 'open' ? 'disputed' : 'unpaid'));
    }
    if (sortBy === 'statusDesc') {
      sortedCitations = sortedCitations.sort((a, b) => (b?.payment_on ? 'paid' : b?.dispute?.status === 'open' ? 'disputed' : 'unpaid').localeCompare(a?.payment_on ? 'paid' : a?.dispute?.status === 'open' ? 'disputed' : 'unpaid'));
    }
    if (sortBy === 'offensesAsc') {
      sortedCitations = sortedCitations.sort((a, b) => getPreviousCitationsCount(a) - getPreviousCitationsCount(b));
    }
    if (sortBy === 'offensesDesc') {
      sortedCitations = sortedCitations.sort((a, b) => getPreviousCitationsCount(b) - getPreviousCitationsCount(a));
    }

    return sortedCitations.slice()
  }

  const citationAction = (citation, action) => {
    if (action === 'view_receipt') {
      window.open(citation.payment.receipt_url)
    }
    if (action === 'view_citation') {
      window.location.href = './citation/' + citation.violation_number
    }
    if (action === 'mark_paid') {
      let tempCitations = [...citations]
      let index = tempCitations.findIndex(cit => cit.id === citation.id)
      tempCitations[index].status = "paid"
      tempCitations[index].payment_on = moment.utc().toISOString()
      tempCitations[index].payment = {
        type: 'other',
        amount: parseFloat(citation.violations_total).toFixed(2)
      }
      props.markAsPaid(citation)
      setCitations(tempCitations)
    }
    if (action === 'view_dispute') {
      setSelectedDispute(citation);
      setShowDisputeModal(true);
    }
    if (action === 'ai_analyze_dispute') {
      setSelectedForAnalysis(citation);
      setShowAnalysisModal(true);
    }
    if (action === 'take_payment') {
      window.open(WEB_PAYMENT_URL + '/violations/' + citation.vehicle)
    }
    if (action === 'void_warning') {
      setWarningToVoid(citation);
      setShowVoidModal(true);
    }
  }


  const getCsvStatus = (citation) => {
    if (citation?.status === 'void') {
      return ('Void')
    } else if (citation?.payment_on) {
      return ('Paid')
    } else if (citation?.dispute?.status === 'open') {
      return ('Disputed')
    } else if (citation?.status === 'closed') {
      return ('Closed')
    } else {
      return ('Unpaid')
    }
  }

  // Add this function to toggle dropdown state

  // Memoize date calculations
  const datePresets = React.useMemo(() => ({
    today: {
      start: startOfDay(new Date()),
      end: endOfDay(new Date())
    },
    yesterday: {
      start: startOfDay(sub(new Date(), { days: 1 })),
      end: endOfDay(sub(new Date(), { days: 1 }))
    },
    lastWeek: {
      start: startOfDay(sub(new Date(), { days: 6 })),
      end: endOfDay(new Date())
    },
    lastMonth: {
      start: startOfDay(sub(new Date(), { days: 29 })),
      end: endOfDay(new Date())
    }
  }), []);

  // Memoize date handlers
  const handleDateChange = React.useCallback((type, date) => {
    if (!date) return;
    
    if (type === 'start') {
      setStartDate(date);
      localStorage.setItem('enforcePlus_startDate', date.toISOString());
    } else {
      setEndDate(date);
      localStorage.setItem('enforcePlus_endDate', date.toISOString());
    }
  }, []);

  // Memoize preset handler
  const handlePresetClick = React.useCallback((preset) => {
    const { start, end } = datePresets[preset];
    setStartDate(start);
    setEndDate(end);
    localStorage.setItem('enforcePlus_startDate', start.toISOString());
    localStorage.setItem('enforcePlus_endDate', end.toISOString());
    setShowDatePickerModal(false);
  }, [datePresets]);

  // Memoize formatted dates with a more compact format
  const formattedDateRange = React.useMemo(() => {
    return `${moment(startDate).format('D MMM')} - ${moment(endDate).format('D MMM YY')}`;
  }, [startDate, endDate]);

  // Add click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (columnSelectorRef.current && !columnSelectorRef.current.contains(event.target)) {
        setShowColumnSelector(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Add function to handle voiding a warning
  const handleVoidWarning = () => {
    if (!warningToVoid) return;
    
    // Update local state immediately
    let tempCitations = [...citations];
    let index = tempCitations.findIndex(cit => cit.id === warningToVoid.id);
    if (index !== -1) {
      tempCitations[index] = {
        ...tempCitations[index],
        status: 'void'
      };
      setCitations(tempCitations);
    }
    
    // Call API to update backend (assuming this exists in your props)
    if (props.voidCitation) {
      props.voidCitation(warningToVoid);
    }
    
    // Close the modal
    setShowVoidModal(false);
    setWarningToVoid(null);
  }

  return (
    <Container fluid className="main-content-container px-4">
      <style>
        {`
          .citation-row:hover {
            background-color: rgba(33, 170, 115, 0.03);
            cursor: pointer;
          }
          
          .table th {
            border-top: none;
          }
          
          .table td {
            vertical-align: middle;
          }
          
          .actions-dropdown-right .dropdown-menu {
            right: 0 !important;
            left: auto !important;
            transform: none !important;
          }
          
          .filter-active .select__control {
            border-color: #21AA73 !important;
            border-width: 2px !important;
            box-shadow: 0 0 5px rgba(33, 170, 115, 0.2) !important;
            background-color: rgba(33, 170, 115, 0.05) !important;
          }
        `}
      </style>
      
      <Row noGutters className="page-header py-4">
        <PageTitle title="Warnings" className="text-sm-left mb-3" />
      </Row>

      <Card small className="mb-4" style={{
        borderRadius: '6px', 
        boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
        border: '1px solid #eaedf3'
      }}>
        <CardHeader className="border-bottom">
          <Row>
            <Col xs={12} className="d-flex align-items-center">
              <h6 className="m-0 mr-3 font-weight-bold d-flex align-items-center">
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73', opacity: 0.8}} />
                ({filterCitations().length})
              </h6>

              {props.user.type === 'super' && (
                <Select
                  id="feClients"
                  className={client !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                  classNamePrefix="select"
                  placeholder="All clients"
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: '180px'
                    }),
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                      boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                      '&:hover': {
                        borderColor: 'rgba(33, 170, 115, 0.4)'
                      }
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected 
                        ? 'rgba(33, 170, 115, 0.1)' 
                        : state.isFocused 
                          ? 'rgba(33, 170, 115, 0.05)' 
                          : null,
                      color: state.isSelected ? '#21AA73' : base.color,
                      padding: '10px 12px',
                      borderBottom: '1px solid #eaedf3',
                      '&:last-child': {
                        borderBottom: 'none'
                      }
                    })
                  }}
                  value={client === 'all' 
                    ? { value: 'all', label: 'All clients' } 
                    : props.clients && props.clients.find(c => c.id === client) 
                      ? { value: client, label: props.clients.find(c => c.id === client).name }
                      : { value: 'all', label: 'All clients' }
                  }
                  onChange={(selectedOption) => setClient(selectedOption.value)}
                  options={[
                    { value: 'all', label: 'All clients' },
                    ...props.clients && props.clients.sort((a, b) => a.name.localeCompare(b.name)).map(c => ({
                      value: c.id,
                      label: c.name
                    })) || []
                  ]}
                />
              )}

              <Button 
                theme="white"
                onClick={() => setShowDatePickerModal(true)}
                className="d-flex align-items-center mr-2"
                style={{
                  borderColor: '#dfe3e9',
                  padding: '0.4375rem 0.75rem',
                  height: '36px',
                  width: '180px',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  justifyContent: 'space-between',
                  whiteSpace: 'nowrap'
                }}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                  <span style={{ color: '#495057', fontSize: '13px' }}>{formattedDateRange}</span>
                </div>
              </Button>

              {!(props.user?.embed && props.user?.location) && (
                <Select
                  id="feLocations"
                  className={location !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                  classNamePrefix="select"
                  placeholder="All locations"
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: '180px'
                    }),
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                      boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                      '&:hover': {
                        borderColor: 'rgba(33, 170, 115, 0.4)'
                      }
                    })
                  }}
                  value={location === 'all'
                    ? { value: 'all', label: 'All locations' }
                    : props.locations && props.locations.find(loc => loc.id === location)
                      ? { value: location, label: props.locations.find(loc => loc.id === location).name }
                      : { value: 'all', label: 'All locations' }
                  }
                  onChange={(selectedOption) => setLocation(selectedOption.value)}
                  options={[
                    { value: 'all', label: 'All locations' },
                    ...props.locations && props.locations.sort((a, b) => a.name.localeCompare(b.name)).map(loc => ({
                      value: loc.id,
                      label: loc.name
                    })) || []
                  ]}
                />
              )}


              <div className="search-container flex-grow-1 mr-3" style={{ position: 'relative', maxWidth: '100%' }}>
                <input
                  type="text"
                  placeholder="Search warnings..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px 32px 8px 36px',
                    fontSize: '14px',
                    border: '1px solid #dfe3e9',
                    borderRadius: '4px',
                    backgroundColor: '#f8f9fa',
                    transition: 'all 0.2s ease',
                    outline: 'none',
                    height: '36px'
                  }}
                  onFocus={(e) => {
                    e.target.style.backgroundColor = '#fff';
                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(33, 170, 115, 0.1)';
                    e.target.style.borderColor = 'rgba(33, 170, 115, 0.4)';
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = '#dfe3e9';
                  }}
                />
                <FontAwesomeIcon 
                  icon={faSearch} 
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#818ea3'
                  }}
                />
                {search && (
                  <FontAwesomeIcon 
                    icon={faTimes}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#818ea3',
                      cursor: 'pointer'
                    }}
                    onClick={() => setSearch('')}
                  />
                )}
              </div>

              <div style={{ display: 'flex', gap: '8px' }}>
                <div style={{ width: '180px' }}>
                  <DownloadButton
                    filename={"enforceplus_citations"}
                    fileData={generateFileData()}
                    showPdfLoading={endablePdfMode}
                    createPdf={() => generateFilePdf()}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="px-4">
          {props.gettingAllCitations ? (
            <div className="loading-container text-center py-5">
              <ActivityIndicator size="large" />
              <p className="mt-3 text-muted">Loading warnings data...</p>
            </div>
          ) : filterCitations().length === 0 ? (
            <div className="text-center py-5">
              <FontAwesomeIcon icon={faFileInvoice} size="2x" style={{color: '#21AA73', marginBottom: '10px', opacity: 0.8}} />
              <h6>No warnings found</h6>
              <p style={{fontSize: '12px', color: '#9EA0A5'}}>Try changing your filters or date range.</p>
            </div>
          ) : (
            <>
              <div className="table-responsive" id="content-id">
                <table className="table mb-0">
                  <thead className="bg-light">
                    <tr>
                      {visibleColumns.license_plate && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'licenseAsc' ? 'licenseAsc' : 'licenseDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            License plate
                            {sortBy === 'licenseAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'licenseDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.id && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'idAsc' ? 'idAsc' : 'idDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            #ID
                            {sortBy === 'idAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'idDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.date_time && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'dateDesc' ? 'dateDesc' : 'dateAsc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Date/Time
                            {sortBy === 'dateDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'dateAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.location && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'locationAsc' ? 'locationAsc' : 'locationDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Location
                            {sortBy === 'locationAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'locationDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.issued_by && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'userAsc' ? 'userAsc' : 'userDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Issued by
                            {sortBy === 'userAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'userDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.previous_offenses && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'offensesAsc' ? 'offensesAsc' : 'offensesDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Citations
                            {sortBy === 'offensesAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'offensesDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      
                      { !endablePdfMode && (
                        <th scope="col" className="border-0 text-right d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div ref={columnSelectorRef} style={{ position: 'relative', display: 'inline-block', marginRight: '12px' }}>
                            <Button
                              theme="white"
                              size="sm"
                              style={{
                                borderColor: '#dfe3e9',
                                color: '#818ea3',
                                height: '24px',
                                padding: '0 8px',
                                fontSize: '11px',
                                minWidth: '80px'
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowColumnSelector(!showColumnSelector);
                              }}
                            >
                              <FontAwesomeIcon icon={faColumns} className="mr-1" size="sm" />
                              Columns
                            </Button>

                            {showColumnSelector && (
                              <div 
                                style={{
                                  position: 'absolute',
                                  top: 'calc(100% + 4px)',
                                  right: '0',
                                  width: '220px',
                                  backgroundColor: '#fff',
                                  boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                                  borderRadius: '6px',
                                  border: '1px solid #eaedf3',
                                  zIndex: 1050,
                                  padding: '12px'
                                }}
                              >
                                <div style={{ 
                                  borderBottom: '1px solid #eaedf3', 
                                  paddingBottom: '8px', 
                                  marginBottom: '8px',
                                  fontSize: '13px',
                                  fontWeight: '600',
                                  color: '#3D5170'
                                }}>
                                  Show/Hide Columns
                                </div>
                                {allColumns.map(column => (
                                  <div 
                                    key={column.id}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: '6px 0',
                                      cursor: 'pointer',
                                      transition: 'background-color 0.2s ease',
                                      margin: '0 -12px',
                                      padding: '6px 12px'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = 'rgba(33, 170, 115, 0.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVisibleColumns(prev => ({
                                        ...prev,
                                        [column.id]: !prev[column.id]
                                      }));
                                    }}
                                  >
                                    <div style={{
                                      width: '16px',
                                      height: '16px',
                                      border: '2px solid',
                                      borderColor: visibleColumns[column.id] ? '#21AA73' : '#dfe3e9',
                                      borderRadius: '3px',
                                      marginRight: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: visibleColumns[column.id] ? '#21AA73' : 'transparent',
                                      transition: 'all 0.2s ease'
                                    }}>
                                      {visibleColumns[column.id] && (
                                        <FontAwesomeIcon 
                                          icon={faCheck} 
                                          style={{ 
                                            color: '#fff',
                                            fontSize: '10px'
                                          }} 
                                        />
                                      )}
                                    </div>
                                    <span style={{
                                      fontSize: '13px',
                                      color: '#495057'
                                    }}>
                                      {column.label}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </th>
                      )}
                      { !endablePdfMode &&
                        <th scope="col" className="border-0"></th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {props.warnings && filterCitations().length > 0 && generateList().map(citation => {
                      return (
                        <React.Fragment key={citation.id}>
                          <tr style={{transition: 'background-color 0.2s ease'}} className="citation-row">
                            {visibleColumns.license_plate && (
                              <td style={{padding: '12px'}}>
                                <span style={{fontWeight: '500'}}>{citation.license_plate}</span>
                              </td>
                            )}
                            {visibleColumns.id && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{citation.violation_number}</span>
                              </td>
                            )}
                            {visibleColumns.date_time && (
                              <td style={{padding: '12px'}}>
                                <span style={{color: '#495057'}}>{moment(citation.created_at).format('MM/DD/Y')}
                                  <div style={{fontSize: '12px', color: '#818ea3'}}>{moment(citation.created_at).format('h:mm a')}</div>
                                </span>
                              </td>
                            )}
                            {visibleColumns.location && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{citation.location_name}</span>
                              </td>
                            )}
                            {visibleColumns.issued_by && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{props.users.find(user => user.id === citation.user)?.name}</span>
                              </td>
                            )}
                            {visibleColumns.previous_offenses && (
                              <td style={{padding: '12px'}} className={"text-center"}>
                                <span style={{
                                  fontWeight: '500', 
                                  color: getPreviousCitationsCount(citation) > 0 ? '#E6492E' : '#495057',
                                  backgroundColor: getPreviousCitationsCount(citation) > 0 ? 'rgba(230, 73, 46, 0.08)' : 'transparent',
                                  padding: getPreviousCitationsCount(citation) > 0 ? '3px 8px' : '0',
                                  borderRadius: '12px'
                                }}>
                                  {getPreviousCitationsCount(citation)}
                                </span>
                              </td>
                            )}
                            
                            { !endablePdfMode &&
                              <td className={"text-right d-none d-md-table-cell"}>
                                <RowActions>
                                    
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      citationAction(citation, 'view_citation');
                                    }}>
                                      <FontAwesomeIcon icon={faFile} className="mr-2" style={{color: '#818ea3'}} />
                                      View warning
                                    </RowActions.Item>

                                    {/* Add Void Warning action */}
                                    {citation.status !== 'void' && (
                                      <RowActions.Item onClick={(e) => {
                                        e.stopPropagation();
                                        citationAction(citation, 'void_warning');
                                      }}>
                                        <FontAwesomeIcon icon={faTimesCircle} className="mr-2" style={{color: '#818ea3'}} />
                                        Void warning
                                      </RowActions.Item>
                                    )}

                                  </RowActions>
                              </td>
                            }
                          </tr>
                            {!endablePdfMode && (
                          <tr className="d-md-none d-xs-table-row">
                            <td className="border-top-0"></td>
                            <td colSpan={
                              // Calculate colspan based on visible columns
                              Object.values(visibleColumns).filter(Boolean).length - 1 // Subtract 1 for the first column
                            } className={"text-right border-top-0"}>
                                <RowActions>
                                    
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      citationAction(citation, 'view_citation');
                                    }}>
                                      <FontAwesomeIcon icon={faFile} className="mr-2" style={{color: '#818ea3'}} />
                                      View warning
                                    </RowActions.Item>
                                    
                                    {/* Add Void Warning action (mobile) */}
                                    {citation.status !== 'void' && (
                                      <RowActions.Item onClick={(e) => {
                                        e.stopPropagation();
                                        citationAction(citation, 'void_warning');
                                      }}>
                                        <FontAwesomeIcon icon={faTimesCircle} className="mr-2" style={{color: '#818ea3'}} />
                                        Void warning
                                      </RowActions.Item>
                                    )}
                                    
                                  </RowActions>
                            </td>
                          </tr>
                            )}
                          </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <Pagination
                data={filterCitations()}
                pageSize={pageSize}
                page={page}
                onPageChange={(newPage) => setPage(newPage)}      
                onPageSizeChange={handlePageSizeChange}
              />
            </>
          )}
        </CardBody>
      </Card>

      {/* Date Picker Modal */}
      <Modal
        open={showDatePickerModal}
        toggle={() => setShowDatePickerModal(!showDatePickerModal)}
        size="lg"
        className="date-picker-modal"
      >
        <ModalHeader toggle={() => setShowDatePickerModal(false)}>
          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
          Select Date Range
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md="8">
              <Card>
                <CardBody className="p-4">
                  <div className="d-flex" style={{ gap: '24px' }}>
                    <div className="flex-grow-1">
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'start' ? null : 'start')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {startDate ? moment(startDate).format('MMM D, YYYY') : 'Select start date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'start' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                              handleDateChange('start', date);
                              setActiveCalendar('end');
                            }}
                            maxDate={endDate || new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                    <div className="flex-grow-1">
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'end' ? null : 'end')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {endDate ? moment(endDate).format('MMM D, YYYY') : 'Select end date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'end' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                              handleDateChange('end', date);
                              setActiveCalendar(null);
                            }}
                            minDate={startDate}
                            maxDate={new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <style>
                    {`
                      .single-date-calendar .react-datepicker__day--selected {
                        background-color: #21AA73 !important;
                        border-radius: 50% !important;
                      }
                      .single-date-calendar .react-datepicker__day--in-range,
                      .single-date-calendar .react-datepicker__day--in-selecting-range {
                        background-color: transparent !important;
                        color: inherit !important;
                      }
                      .single-date-calendar .react-datepicker__day:hover {
                        background-color: rgba(33, 170, 115, 0.1) !important;
                        border-radius: 50% !important;
                      }
                    `}
                  </style>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card>
                <CardHeader className="border-bottom">
                  <h6 className="m-0">Quick Select</h6>
                </CardHeader>
                <CardBody className="p-3">
                  <div className="d-flex flex-column" style={{ gap: '8px' }}>
                    <Button 
                      theme="light" 
                      size="sm" 
                      block
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('today')}
                    >
                      Today
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('yesterday')}
                    >
                      Yesterday
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('lastWeek')}
                    >
                      Last 7 days
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('lastMonth')}
                    >
                      Last 30 days
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button theme="light" onClick={() => setShowDatePickerModal(false)}>Cancel</Button>
          <Button theme="primary" onClick={() => setShowDatePickerModal(false)}>Apply</Button>
        </ModalFooter>
      </Modal>

      {/* Void Warning Confirmation Modal */}
      <Modal
        open={showVoidModal}
        toggle={() => setShowVoidModal(!showVoidModal)}
        size="sm"
      >
        <ModalHeader toggle={() => setShowVoidModal(false)}>
          <FontAwesomeIcon icon={faTimesCircle} className="mr-2" style={{ color: '#6c757d' }} />
          Void Warning
        </ModalHeader>
        <ModalBody className="py-4">
          <p>Are you sure you want to void this warning?</p>
          <p className="mb-0" style={{ fontSize: '13px', color: '#818ea3' }}>
            Warning #: <strong>{warningToVoid?.violation_number}</strong><br />
            License plate: <strong>{warningToVoid?.license_plate}</strong>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button theme="light" onClick={() => setShowVoidModal(false)}>Cancel</Button>
          <Button theme="danger" onClick={handleVoidWarning}>Void Warning</Button>
        </ModalFooter>
      </Modal>
      
    </Container>
  );
}

export default Warnings;
